import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { PHONE_NUMBER, WHATSAPP_NUMBER } from "@/lib/api";

export const Footer = () => (
  <footer
    id="contatti"
    data-testid="site-footer"
    className="bg-slate-900 text-slate-200 mt-32"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="italic-flag mb-6" />
          <h3 className="font-serif-display text-4xl lg:text-5xl font-light tracking-tight leading-[1.1] text-white">
            Hai bisogno di un<br/>
            <span className="italic text-red-500">motore o un cambio</span>?
          </h3>
          <p className="mt-6 text-slate-400 max-w-md leading-relaxed">
            Contattaci ora per un preventivo gratuito. Risposta tecnica entro 24 ore,
            garanzia 12 mesi su ogni ricambio.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`}
              data-testid="footer-call-cta"
              className="inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3.5 text-xs tracking-[0.2em] uppercase transition-colors"
            >
              <Phone className="w-4 h-4" /> Chiama Subito
            </a>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Ciao%20Officine%20Franco%2C%20vorrei%20informazioni%20su%20un%20ricambio.`}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-cta"
              className="inline-flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3.5 text-xs tracking-[0.2em] uppercase transition-colors"
            >
              WhatsApp
            </a>
          </div>
        </div>

        <div className="lg:col-span-4 lg:col-start-7">
          <div className="text-xs tracking-[0.25em] uppercase text-slate-500 mb-6">
            Coordinate
          </div>
          <div className="space-y-5">
            <Row icon={Phone} label="Telefono" value={PHONE_NUMBER} testid="footer-phone" href={`tel:${PHONE_NUMBER.replace(/\s/g, "")}`} />
            <Row icon={Mail} label="Email" value="info@officinafranco.com" testid="footer-email" href="mailto:info@officinafranco.com" />
            <Row icon={MapPin} label="Sede" value={<>Officina Franco Srl<br/>Via Laveroni, 8/A — 14100 Asti</>} testid="footer-address" />
            <Row icon={Clock} label="Orari" value="Lun–Ven · 08:30 – 18:30" />
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="text-xs tracking-[0.25em] uppercase text-slate-500 mb-6">
            Cosa offriamo
          </div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2"><span className="text-red-500">▸</span> Motori usati e revisionati</li>
            <li className="flex items-start gap-2"><span className="text-red-500">▸</span> Cambi manuali e automatici</li>
            <li className="flex items-start gap-2"><span className="text-red-500">▸</span> Garanzia 12 mesi inclusa</li>
            <li className="flex items-start gap-2"><span className="text-red-500">▸</span> Spedizioni in tutta Italia</li>
            <li className="flex items-start gap-2"><span className="text-red-500">▸</span> Banco prova certificato</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between gap-4 text-xs text-slate-500">
        <div>© {new Date().getFullYear()} Officina Franco Srl · Tutti i diritti riservati</div>
        <div className="tracking-wider">P.IVA 01539170058 · Made in Italy</div>
      </div>
    </div>
  </footer>
);

const Row = ({ icon: Icon, label, value, testid, href }) => {
  const inner = (
    <div className="flex items-start gap-3 border-t border-slate-800 pt-4">
      <Icon className="w-4 h-4 mt-1 text-red-500" />
      <div>
        <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500">{label}</div>
        <div className="text-sm text-slate-200 mt-1">{value}</div>
      </div>
    </div>
  );
  return href ? <a href={href} data-testid={testid} className="block hover:bg-slate-800/30 -mx-2 px-2 transition-colors">{inner}</a> : <div data-testid={testid}>{inner}</div>;
};
